export const pageValueEnum = {
	globalConfig: '10',
	menu: '11',
	home: '5',
	detail: '20',
	classify: '30',
	pcNav: '1',
	phoneNav:'2',
	pcFooter:'3',
	phoneFooter: '4',
	globalDialog:'40'
}
